import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { MsalGuard } from './msal';
import { InvestigationComponent } from './pages/investigation/investigation/investigation.component';
import { PlanVersusActualComponent } from './pages/plan-versus-actual/plan-versus-actual.component';
import { PlanVersusActualSupplierComponent } from './pages/plan-versus-actual/plan-versus-actual-supplier/plan-versus-actual-supplier.component';
import { PlanVersusActualDockComponent } from './pages/plan-versus-actual/plan-versus-actual-supplier/plan-versus-actual-dock/plan-versus-actual-dock.component';
import { PlanVersusActualPartNumberComponent } from './pages/plan-versus-actual/plan-versus-actual-supplier/plan-versus-actual-dock/plan-versus-actual-part-number/plan-versus-actual-part-number.component';
import { reasonIdComponent } from './pages/masterSettings/reason-id/reason-id.component'
import { DailyexpediteComponent } from './pages/masterSettings/daily-expedite/daily-expedite.component'
import { RootCauseComponent } from './pages/masterSettings/root-cause/root-cause.component'
import { HistoryComponent } from './pages/history/history.component';
import { UnauthorizedComponent } from './pages/unauthorized/unauthorized.component';


const routes: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full', data: { breadcrumb: 'Expedite Entry' } },//, canActivate: [MsalGuard]
  { path: 'home', component: HomeComponent, data: { breadcrumb: 'Expedite Entry' }, canActivate: [MsalGuard] },
  //investigation
  { path: 'investigation', component: InvestigationComponent, data: { breadcrumb: 'Investigation' }, canActivate: [MsalGuard] },
  //PlanVersusActual

  {
    path: 'plant', data: { breadcrumb: 'Plan Versus Actual' }, children: [
      { path: '', component: PlanVersusActualComponent, data: { breadcrumb: '' }, canActivate: [MsalGuard] },
      {
        path: 'supplier', data: { breadcrumb: 'Supplier' }, children: [
          { path: '', component: PlanVersusActualSupplierComponent, data: { breadcrumb: '' }, canActivate: [MsalGuard] },
          {
            path: 'dock', data: { breadcrumb: 'Dock' }, children: [
              { path: '', component: PlanVersusActualDockComponent, data: { breadcrumb: '' }, canActivate: [MsalGuard] },
              { path: 'part-number', component: PlanVersusActualPartNumberComponent, data: { breadcrumb: 'Part Number' }, canActivate: [MsalGuard] },
            ],
          },
        ]
      },
    ],
  },

  //MasterSettings
  {
    path: '', data: { breadcrumb: 'Master Settings' }, children: [
      { path: 'reasonId', component: reasonIdComponent, data: { breadcrumb: 'Reason IDs' }, canActivate: [MsalGuard] },
      { path: 'dailyExpedite', component: DailyexpediteComponent, data: { breadcrumb: 'Daily Expedite Targets' }, canActivate: [MsalGuard] },
      { path: 'rootCause', component: RootCauseComponent, data: { breadcrumb: 'Root Cause Dropdown' }, canActivate: [MsalGuard] },
    ],
  },
  //history
  { path: 'history', component: HistoryComponent, data: { breadcrumb: 'History' }, canActivate: [MsalGuard] },
  { path: 'unauthorized', component: UnauthorizedComponent, data: { breadcrumb: 'Unauthorized' } }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
